import React, { useEffect, useState } from 'react';
import './Equipments.scss';
import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';
import Mobilization from './Mobilization/Mobilization';
import Demobilization from './Demobilization/Demobilization';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    GetMobDetails_getMobDetails as MobDetailsType,
    GetDemobDetails_getDemobDetails as DemobDetailsType,
    EquipmentInfoType,
    GetAllLocations,
    GetAllLocations_getAllLocations as LocationType,
    UpdateAssetPlansInput,
    CreateAssetLoadInput,
    CreateAssetLoad,
    GetFullJobProfile,
    EditLeapFrog,
} from '../../../types/schemaTypes';
import SearchableDropdown, { DropdownOption } from '../../_common/SearchableDropdown/SearchableDropdown';
import { useMutation, useQuery } from '@apollo/client/react';
import { GET_ALL_LOCATIONS, GET_JOB_PROFILE, GET_MOB_DETAILS } from '../../../graphql/client/queries';
import { CustomButton, Loading } from '../../_common';
import { CREATE_ASSET_LOAD, EDIT_LEAP_FROG, UPDATE_ASSET_PLANS } from '../../../graphql/client/mutations';
import AddAssetLoadModal from './AddAssetLoadModal/AddAssetLoadModal';
import { ToastContainer, toast } from 'react-toastify';
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';
import { useStoreContext } from '../../App/StoreProvider';
import { toastOpt } from '../../../utils/helpers/toastHelper';
import { useParams } from 'react-router-dom';
import JobMenuItems from '../../Header/JobMenuItemsHeader/JobMenuItems';
import { Modal } from 'react-bootstrap';

const EquipmentsForTab = ({ match }: any): React.ReactElement => {
    const [tabTitle, setTabTitle] = useState(document.title);

    const jobId = parseInt(useParams().jobId ?? '');
    const JobEquipmentsHubConnection = new HubConnectionBuilder()
        .withUrl(import.meta.env.VITE_NOTIFICATION_HUB_URL + 'JobEquipmentsHub', {
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets
        })
        .withAutomaticReconnect()
        .build();

    const [state] = useStoreContext();
    const { auth } = state;
    const userName = auth.user ? auth.user.profile.email : '';

    const { data, loading, error } = useQuery<GetFullJobProfile>(GET_JOB_PROFILE,
        {
            variables: {
                jobId: jobId
            },
            skip: !jobId || jobId === 0,
        }
    )
    let jobName = '';
    if (data && data.getJobProfile) {
        jobName = data.getJobProfile.jobDetails?.jobName ?? '';
    }
    document.title = jobName;

    const [mobDetailsFromSignalr, setMobDetailsFromSignalr] = useState<MobDetailsType>();
    const [demobDetailsFromSignalr, setDemobDetailsFromSignalr] = useState<DemobDetailsType>();

    const isViewEquipmentPlanEnabled = useAuthContext().userHasPermission(PermissionEnum.ViewEquipmentPlan);
    const isAddEquipmentsEnabled = useAuthContext().userHasPermission(PermissionEnum.AddAssetLoads);
    const isEditEquipmentPlanEnabled = useAuthContext().userHasPermission(PermissionEnum.EditEquipmentPlan);

    const [selectedTab, setSelectedTab] = useState<'Mob' | 'Demob'>('Mob');
    const [showAddLoadModal, setShowAddLoadModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [equipmentsToUpdate, setEquipmentsToUpdate] = useState<EquipmentInfoType[]>([]);

    const [isLeapFrogEdit, setIsLeapFrogEdit] = useState(false);
    const [isLeapFrog, setIsLeapFrog] = useState(false);

    const searchIcon = <FontAwesomeIcon icon={{ prefix: 'fas', iconName: 'search' }} />;
    const [locationtype, setLocationType] = useState('-1');
    const [locationid, setLocationId] = useState(-1);
    const [location, setLocation] = useState(' ');

    const [groupName, setGroupName] = useState(`-1_-1_Job_${jobId}`);
    useEffect(() => {
        if (selectedTab === "Mob") {
            setGroupName(`-1_-1_Job_${jobId}`);
            sessionStorage.setItem('group', `-1_-1_Job_${jobId}`);
        } else {
            setGroupName(`Job_${jobId}_-1_-1`);
            sessionStorage.setItem('group', `Job_${jobId}_-1_-1`);
        }
    }, [selectedTab])

    useEffect(() => {
        if (auth.user && !auth.user.expired) {
            if (JobEquipmentsHubConnection) {
                JobEquipmentsHubConnection
                    .start()
                    .then(result => {
                        console.log('Connecting to JobEquipmentsHub Server');
                        JobEquipmentsHubConnection.invoke('AddToGroup', groupName).catch(e => console.log('JobEquipmentsHub Error: ', e));
                        console.log('Connected ', userName, 'to JobEquipmentsHub server group ', groupName);
                    })
                    .catch(e => console.log('Connection to JobEquipmentsHub Server failed: ', e));
            }
        }
    }, [groupName])


    if (JobEquipmentsHubConnection) {
        JobEquipmentsHubConnection.on('MobDeMobViewStatus', (userName, result) => {
            const value = JSON.parse(result);
            const mobStats = value.mobstats;
            const demobStats = value.demobstats;
            const jobInfo = value.jobInfo;
            const grpName = value.groupName;

            if (grpName === sessionStorage.getItem('group')) {
                console.log('Inside BroadcastMobDeMobViewStatus');
                console.log('GroupName --> ', sessionStorage.getItem('group'));
                console.table(value);

                setMobDetailsFromSignalr({
                    __typename: 'GetMobDetailsResponse',
                    stats: mobStats,
                    jobInfo: jobInfo,
                });
                setDemobDetailsFromSignalr({
                    __typename: 'GetDemobDetailsResponse',
                    stats: demobStats,
                    jobInfo: jobInfo,
                });
            }
        });
    }

    const locations: LocationType[] = [];
    const locationsDropdownOptions: DropdownOption[] = [];
    const { data: locationsData } = useQuery<GetAllLocations>(GET_ALL_LOCATIONS, {
        variables: {
            input: {
                locationType: "Job",
                locationId: jobId,
            }
        },
        fetchPolicy: 'network-only',
        skip: !isViewEquipmentPlanEnabled,
    });
    if (locationsData && locationsData.getAllLocations) {
        locationsData.getAllLocations.map(item => {
            if (item && item.locationId && item.descrip) {
                locations.push(item);
                locationsDropdownOptions.push({
                    id: item.locationId,
                    name: `${item.descrip} (${item.locationType})`
                })
            }
        })
    }

    const handleOnChangeLocation = (value: number) => {
        setMobDetailsFromSignalr(undefined);
        setDemobDetailsFromSignalr(undefined);
        if (!value) {
            setLocationId(-1);
            setLocationType('-1');
            setLocation(' ');
            if (selectedTab === "Mob") {
                setGroupName(`-1_-1_Job_${jobId}`);
                sessionStorage.setItem('group', `-1_-1_Job_${jobId}`);
            } else {
                setGroupName(`Job_${jobId}_-1_-1`);
                sessionStorage.setItem('group', `Job_${jobId}_-1_-1`);
            }
        }
        else{
            setLocationId(value);
            locations.map(location => {
                if (location.locationId === value && location.locationType) {
                    setLocationType(location.locationType);
                    setLocation(location.descrip ?? ' ');
                    if (selectedTab === "Mob") {
                        setGroupName(`${location.locationType}_${location.locationId}_Job_${jobId}`);
                        sessionStorage.setItem('group', `${location.locationType}_${location.locationId}_Job_${jobId}`);
                    } else {
                        setGroupName(`Job_${jobId}_${location.locationType}_${location.locationId}`);
                        sessionStorage.setItem('group', `Job_${jobId}_${location.locationType}_${location.locationId}`);
                    }
                }
            })

        }
    }

    const handleOnChangeTab = (tabName: 'Mob' | 'Demob') => {
        setMobDetailsFromSignalr(undefined);
        setDemobDetailsFromSignalr(undefined);
        setSelectedTab(tabName);
        setLocationId(-1);
        setLocationType('-1');
        setLocation(' ');
    }

    const handleOnClickAdd = () => {
        setShowAddLoadModal(true);
    }

    const handleOnCancleAdd = () => {
        setShowAddLoadModal(false);
    }

    const handleOnCompleteAdd = (loadIds: number[]) => {
        const idLabel = loadIds.length ? ` - ${loadIds.join(', ')}` : '';
        toast.success(`Equipment Load${loadIds.length === 1 ? '' : 's'}${idLabel} created successfully`, toastOpt);
        setShowAddLoadModal(false);
    }

    const handleOnClickEdit = () => {
        setIsEditMode(true);
    }

    const handleOnCancleEdit = () => {
        setIsEditMode(false);
        setEquipmentsToUpdate([]);
    }

    const handleOnCompleteEdit = () => {
        toast.success("Planned quantity updated successfully", toastOpt);
        handleOnCancleEdit();
    }

    const handleOnClickEditLeapFrog = (isLeapFrog: boolean) => {
        setIsLeapFrogEdit(true);
        setIsLeapFrog(isLeapFrog);
    }

    const handleOnCancleEditLeapFrog = () => {
        setIsLeapFrogEdit(false);
    }

    const handleOnCompleteEditLeapFrog = (variables) => {
        if (variables.input.leapFrog)
            toast.success("Job is setup as a Leap Frog", toastOpt);
        else
            toast.success("Job is no longer a Leap Frog", toastOpt);
        handleOnCancleEditLeapFrog();
    }

    const [createAssetLoad, { loading: createAssetLoadLoading, error: createAssetLoadError }] = useMutation<CreateAssetLoad>(CREATE_ASSET_LOAD, {
        onCompleted: (data) =>
            handleOnCompleteAdd(
                (data.createAssetLoad?.loadIds ?? []).filter((id): id is number => id != null),
            ),
    });

    const [updateAssetPlans, { loading: updateAssetPlansLoading, error: updateAssetPlansError }] = useMutation(UPDATE_ASSET_PLANS, {
        onCompleted: () => handleOnCompleteEdit(),
        refetchQueries: [
            {
                query: GET_MOB_DETAILS,
                variables: {
                    input: {
                        originType: locationtype ?? '-1',
                        originId: locationid ?? -1,
                        destinationId: jobId,
                    }
                },
            }
        ]
    });

    const [editLeapFrog, { loading: editLeapFrogLoading, error: editLeapFrogError }] = useMutation<EditLeapFrog>(EDIT_LEAP_FROG, {
        onCompleted: (data, options) => handleOnCompleteEditLeapFrog(options?.variables),
    });

    const handleOnSaveEdit = () => {
        setMobDetailsFromSignalr(undefined);
        setDemobDetailsFromSignalr(undefined);
        const input: UpdateAssetPlansInput = {
            jobId: jobId,
            equipmentInfo: equipmentsToUpdate,
        }
        updateAssetPlans({
            variables: {
                input: input
            }
        })
    }

    const handleOnSaveAdd = (input: CreateAssetLoadInput) => {
        createAssetLoad({
            variables: {
                input: input
            }
        })
    }

    const handleOnSaveEditLeapFrog = () => {
        editLeapFrog({
            variables: {
                input: {
                    jobId: jobId,
                    leapFrog: isLeapFrog,
                }
            }
        })
    }

    if (!isViewEquipmentPlanEnabled) {
        return (
            <div className="Equipments-Container-For-Tab">
                <div className="Equipments-Header-For-Tab">
                    <div>Equipment: {jobName}</div>
                    <JobMenuItems jobId={jobId.toString()} menu='equipmentsForTab' />
                </div>

                <div className="NoResult-Container Equipments-Unauth-Container">
                    <div className="NoResult-First-Title-Secondary">Unauthorized</div>
                    <div className="NoResult-Second-Title-Secondary">You do not have permission to view this screen</div>
                </div>
            </div>
        )
    }

    return (
        <div className="Equipments-Container-For-Tab">
            <ToastContainer position='top-center' />
            <div className="Equipments-Header-For-Tab">
                <div>Equipment: {jobName}</div>
                <JobMenuItems jobId={jobId.toString()} menu='equipmentsForTab' />
            </div>

            <div className="Equipments-Header-Container Equipments-Header-Container-For-Tab">
                <div className="Equipments-Link-Container Row justify-content-start">
                    <div
                        className={`Equipments-Tab ${selectedTab === 'Mob' && 'Equipments-TabSelected'}`}
                        onClick={() => handleOnChangeTab('Mob')}
                    >
                        Mobilization
                    </div>
                    <div
                        className={`Equipments-Tab ${selectedTab === 'Demob' && 'Equipments-TabSelected'}`}
                        onClick={() => handleOnChangeTab('Demob')}
                    >
                        De-Mobilization
                    </div>
                </div>

                <div className="Equipments-Search-Edit-Container-For-Tab">
                    {!isEditMode && (
                        <div className="Equipments-Search-Container">
                            <SearchableDropdown
                                dropdownOptions={locationsDropdownOptions}
                                id="location"
                                label={selectedTab === "Mob" ? "ORIGIN NAME" : "DESTINATION NAME"}
                                value={location}
                                onSelect={value => { value && handleOnChangeLocation(parseInt(value)) }}
                                autoCompleteEnabled
                                endIcon={searchIcon}
                            />
                        </div>
                    )}

                    {isEditEquipmentPlanEnabled && isEditMode && (
                        <div className="Equipments-Buttons-Container">
                            <div className="Equipments-Cancel-Button">
                                <CustomButton title='Cancel' isBordered onClick={handleOnCancleEdit} />
                            </div>
                            <CustomButton title='Save' onClick={handleOnSaveEdit} />
                        </div>
                    )}

                    {!isEditMode && isAddEquipmentsEnabled && (
                        <div className="Equipments-Edit-Link" onClick={handleOnClickAdd}>
                            <i className="material-icons color Equipments-Add-Icon">
                                add_circle
                            </i>
                            <span className="Equipments-Add-Text">Add Load</span>
                        </div>
                    )}

                    {selectedTab === "Mob" && (
                        !isEditMode && isEditEquipmentPlanEnabled &&
                        <div className="Equipments-Edit-Link" onClick={handleOnClickEdit}>
                            <i className="material-icons color Equipments-Edit-Icon">
                                edit
                            </i>
                            Edit
                        </div>
                    )}
                </div>
            </div>

            {selectedTab === 'Mob' && (
                <Mobilization
                    jobId={jobId}
                    isEditMode={isEditMode}
                    origin={jobName}
                    originId={locationid}
                    originType={locationtype}
                    equipmentsToUpdate={equipmentsToUpdate}
                    setEquipmentsToUpdate={setEquipmentsToUpdate}
                    mobDetailsFromSignalr={mobDetailsFromSignalr}
                    mutationLoading={updateAssetPlansLoading}
                    handleOnClickEditLeapFrog={handleOnClickEditLeapFrog}
                />
            )}
            {selectedTab === 'Demob' && (
                <Demobilization
                    jobId={jobId}
                    destinationId={locationid}
                    destinationType={locationtype}
                    destination={location}
                    demobDetailsFromSignalr={demobDetailsFromSignalr}
                    handleOnClickEditLeapFrog={handleOnClickEditLeapFrog}
                />
            )}

            {
                isAddEquipmentsEnabled && showAddLoadModal && <AddAssetLoadModal
                    loadType={selectedTab}
                    origin={
                        selectedTab === "Mob" ? {
                            id: locationid,
                            name: location,
                            type: locationid !== -1 ? 'Job' : ''
                        } : {
                            id: jobId,
                            name: jobName,
                            type: 'Job'
                        }
                    }
                    destination={
                        selectedTab === "Mob" ? {
                            id: jobId,
                            name: jobName,
                            type: 'Job'
                        } : {
                            id: locationid,
                            name: location,
                            type: locationid !== -1 ? 'Job' : ''
                        }
                    }
                    showModal={showAddLoadModal}
                    loading={createAssetLoadLoading}
                    error={createAssetLoadError}
                    onClickCancel={handleOnCancleAdd}
                    onClickSaveForAdd={handleOnSaveAdd}
                />
            }

            {isLeapFrogEdit && (
                <Modal show={isLeapFrogEdit} onHide={handleOnCancleEditLeapFrog}>
                    <Modal.Header className="Equipments-Edit-Leapfrog">
                        Update Leapfrog
                        <i className="material-icons Equipments-Edit-Leapfrog-X-Button" onClick={handleOnCancleEditLeapFrog}>
                            close
                        </i>
                    </Modal.Header>
                    <Modal.Body>
                        {editLeapFrogLoading && <div className="Equipments-Spinner"><Loading /></div>}
                        {"Are you sure you want to update the Job's Leapfrog value?"}
                    </Modal.Body>
                    <Modal.Footer>
                        <CustomButton title='Cancel' onClick={handleOnCancleEditLeapFrog} isBordered />
                        <CustomButton title='Confirm' onClick={handleOnSaveEditLeapFrog} />
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    );
};

export default EquipmentsForTab;

